import React, { useState, useEffect } from 'react';
import PendientesRelacionar from '../components/PendientesRelacionar';
import PendientesAutorizar from "./../components/PendientesAutorizar";
import TablaDesglocePresupuestoPorID from '../modules/ControlPresupuesto/TablaDesglocePresupuestoPorID';
import HeaderComponent from "./../modules/Shared/components/HeaderComponent";
import PendienteID from './PendienteID';
import dayjs from "dayjs";
import { Typography, Divider, Table, Button, Spin, DatePicker, Tabs } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "./../services/http";
const { RangePicker } = DatePicker;

const ControlPresupuesto = () => {

  const location = useLocation();
  const { from } = location.state;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [nextDays, setnextDays] = useState();
  const [relaciones, setRelaciones] = useState([]);
  const [relacionesFinal, setRelacionesFinal] = useState([]);
  const [relacionesRango, setRelacionesRango] = useState([]);
  const numberFormat = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 });

  const [filteredData, setFilteredData] = useState([]);
  const [dateRange, setDateRange] = useState([]);

  useEffect(() => {
    let currentYear = new Date(from.fecha_creacion).getFullYear();
    let weekNumber = getWeekNumber(from.fecha_creacion);
    let daysOfWeek = getWeekDates(currentYear, weekNumber);
    fetchRelaciones();
    setnextDays(daysOfWeek);
  }, []);

  useEffect(() => {
    if (relaciones.length > 0) {
      let relacionesAgrupadas = agruparPorNumeroRelacion(relaciones);
      let relacionesAgrupadasPorPartida = agruparPorPartida(relacionesAgrupadas);
      setRelacionesFinal(relacionesAgrupadasPorPartida);
      setFilteredData(relacionesAgrupadasPorPartida);
      relacionesAgrupadasPorPartida = setRange(relacionesAgrupadasPorPartida);
    }
  }, [relaciones]);

  const getWeekNumber = (creationDate) => {
    const currentDate = new Date(creationDate);
    const januaryFirst = new Date(currentDate.getFullYear(), 0, 1);
    const daysToNextMonday =
      (januaryFirst.getDay() === 1) ? 0 :
        (7 - januaryFirst.getDay()) % 7;
    const nextMonday =
      new Date(currentDate.getFullYear(), 0,
        januaryFirst.getDate() + daysToNextMonday);

    return (currentDate < nextMonday) ? 52 :
      (currentDate > nextMonday ? Math.ceil(
        (currentDate - nextMonday) / (24 * 3600 * 1000) / 7) : 1);
  }

  const getWeekDates = (year, weekNumber) => {
    // Calcula el primer día del año
    const firstDayOfYear = new Date(year, 0, 1);
    // Obtén el día de la semana del primer día del año (0 = domingo, 6 = sábado)
    const dayOfWeek = firstDayOfYear.getDay();
    // Calcula el número de días hasta el primer viernes (ISO 8601 considera lunes como inicio)
    const daysToFirstThursday = (5 - dayOfWeek + 7) % 7;
    // Calcula el primer jueves del año
    const firstThursday = new Date(firstDayOfYear);
    firstThursday.setDate(firstDayOfYear.getDate() + daysToFirstThursday);
    // Avanza a la semana solicitada
    const targetThursday = new Date(firstThursday);
    targetThursday.setDate(firstThursday.getDate() + (weekNumber - 1) * 7);

    return targetThursday;
  }

  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  const setRange = (relaciones) => {
    if (relaciones !== undefined) {
      let nextDay = nextDays;
      Object.keys(relaciones).map((numeroRelacion, index) => {
        relaciones[numeroRelacion]["fecha_inicio"] = nextDay.toLocaleDateString();
        relaciones[numeroRelacion]["fecha_fin"] = addDays(nextDay, 6).toLocaleDateString('es-MX');
        nextDay = addDays(nextDay, 7);
      })

      return relaciones;
    } else return [];
  }

  const fetchRelaciones = async () => {
    try {
      const response = await axios.HTTP_GET(`/api/v1/relationship/control-budget/${from.id}`);
      setRelaciones(response);
    } catch (error) {
      console.error('Error al cargar las relaciones:', error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const agruparPorNumeroRelacion = (relaciones) => {
    if (relaciones !== undefined) {
      return relaciones.reduce((acumulador, relacion) => {
        const numeroRelacion = relacion.numero_relacion;
        if (!acumulador[numeroRelacion]) {
          acumulador[numeroRelacion] = [];
        }
        acumulador[numeroRelacion].push(relacion);
        return acumulador;
      }, {});
    } else return [];
  };

  const agruparPorPartida = (relaciones) => {
    let relacionPartidas = {};

    if (relaciones !== undefined) {
      Object.keys(relaciones).map((numeroRelacion, index) => {

        let partidasAgrupadas = Object.groupBy(relaciones[numeroRelacion], ({ partida }) => partida);

        relaciones[numeroRelacion] = partidasAgrupadas;

        Object.keys(partidasAgrupadas).map((nombrePartida, index) => {
          let fiscal = partidasAgrupadas[nombrePartida].filter((item) => item.tipo_monto === "Fiscal");
          let noFiscal = partidasAgrupadas[nombrePartida].filter((item) => item.tipo_monto === "No Fiscal");
          relacionPartidas[nombrePartida] = { "montoFiscal": (fiscal.length >= 1 ? fiscal[0].Total : 0), "montoNoFiscal": (noFiscal.length >= 1 ? noFiscal[0].Total : 0) };

          relaciones[numeroRelacion][nombrePartida] = relacionPartidas[nombrePartida];
        });
      });
      return relaciones;
    } else return [];
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'partida',
      key: 'partida',
    },
    {
      title: 'Monto Fiscal',
      dataIndex: 'montoFiscal',
      key: 'montoFiscal',
      render: (text) => `$ ${numberFormat.format(text)}`,
    },
    {
      title: 'Monto No Fiscal',
      dataIndex: 'montoNoFiscal',
      key: 'montoNoFiscal',
      render: (text) => `$ ${numberFormat.format(text)}`,
    },
  ];

  const Navigate = (path, params) => {
    navigate(path, params);
  }

  const calcularSubtotal = (relacion, tipo_monto) => {
    let total = 0;
    Object.keys(relacion).map((nombrePartida) => {
      if (relacion[nombrePartida][tipo_monto] !== null && relacion[nombrePartida][tipo_monto] !== undefined) total += relacion[nombrePartida][tipo_monto];
    });

    return total;
  }

  const handleDateFilter = (dates) => {
    if (!dates || dates.length === 0) {
      setFilteredData(relacionesFinal); // Restablecer si no hay filtro
      setDateRange([]);
      return;
    }

    const [startDate, endDate] = dates.map(date => dayjs(date));

    const filtered = Object.keys(relacionesFinal).reduce((acc, numeroRelacion) => {
      const fechaInicio = dayjs(relacionesFinal[numeroRelacion]?.fecha_inicio, ["D/M/YYYY", "DD/MM/YYYY"]);
      const fechaFin = dayjs(relacionesFinal[numeroRelacion]?.fecha_fin, ["D/M/YYYY", "DD/MM/YYYY"]);

      if (
        (fechaInicio.isAfter(startDate) || fechaInicio.isSame(startDate, "day")) &&
        (fechaFin.isBefore(endDate) || fechaFin.isSame(endDate, "day"))
      ) {
        acc[numeroRelacion] = relacionesFinal[numeroRelacion];
      }

      return acc;
    }, {});

    setFilteredData(filtered);
    setDateRange([startDate, endDate]);
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <Spin size="large" />
        <Typography>Cargando...</Typography>
      </div>
    );
  }

  const itemsTabPresupuesto = [{
    label: "Relaciones",
    key: 1,
    children: <>
      <div>
        <div style={{ width: "100%", textAlign: "center" }}>
          <Typography.Title level={5}>Rango de fecha</Typography.Title>
          <RangePicker onChange={handleDateFilter} style={{ marginBottom: "20px" }} />
        </div>

        {Object.keys(filteredData).map((numeroRelacion, index) => {

          const fechaInicio = relacionesFinal[numeroRelacion]?.fecha_inicio || 'Sin fecha';
          const fechaFin = relacionesFinal[numeroRelacion]?.fecha_fin || 'Sin fecha';

          const subtotalFiscales = calcularSubtotal(relacionesFinal[numeroRelacion], "montoFiscal");
          const subtotalNoFiscales = calcularSubtotal(relacionesFinal[numeroRelacion], "montoNoFiscal");

          return (
            <div key={index} style={{ marginBottom: '48px' }}>
              <Typography.Title level={6}>
                Relación: {numeroRelacion} | {fechaInicio} - {fechaFin}
              </Typography.Title>
              <Table
                dataSource={Object.keys(filteredData[numeroRelacion])
                  .filter(
                    (nombrePartida) =>
                      nombrePartida !== 'fecha_inicio' &&
                      nombrePartida !== 'fecha_fin'
                  )
                  .map((nombrePartida) => ({
                    key: nombrePartida,
                    partida: nombrePartida,
                    montoFiscal: filteredData[numeroRelacion][nombrePartida].montoFiscal,
                    montoNoFiscal: filteredData[numeroRelacion][nombrePartida].montoNoFiscal
                  }))}
                columns={columns}
                pagination={false}
                bordered
                footer={() => (
                  <div style={{ width: "100%", "display": "flex", "justifyContent": "space-between", "alignItems": "center" }}>
                    <div>
                      <strong>Total: </strong> $ {numberFormat.format(subtotalFiscales + subtotalNoFiscales)}
                    </div>
                    <div>
                      <strong>Subtotal Fiscales: </strong> $ {numberFormat.format(subtotalFiscales)}
                    </div>
                    <div>
                      <strong>Subtotal No Fiscales: </strong> $ {numberFormat.format(subtotalNoFiscales)}
                    </div>
                  </div>
                )}
              />
            </div>
          )
        })}
      </div>
    </>
  }, {
    label: "Desgloce de presupuesto",
    key: 2,
    children: <>
      <TablaDesglocePresupuestoPorID obra={from} />
    </>
  }]

  const itemsTab = [{
    label: "Control de Presupuesto",
    key: 1,
    children: <>
      <HeaderComponent title={`Control de Presupuesto - ${from.nombre_obra}`} />
      <Tabs
        defaultActiveKey="1"
        tabPosition={"top"}
        style={{ marginTop: 10 }}
        items={itemsTabPresupuesto}
      />
    </>
  }, {
    label: "Pendientes de Relacionar",
    key: 2,
    children: <>
      <PendientesRelacionar obra={from} />
    </>
  },
  {
    label: "Pendientes de Autorizar",
    key: 3,
    children: <>
      <PendientesAutorizar obra={from} />
    </>
  }, {
    label: "Presupuesto ID",
    key: 4,
    children: <>
      <PendienteID obra={from} />
    </>
  }];

  return (
    <>
      <Tabs
        defaultActiveKey="1"
        tabPosition={"left"}
        style={{ marginTop: 30 }}
        items={itemsTab}
      />
    </>
  )

  // | {relacionesRango[numeroRelacion][0]["fecha_inicio"]} - {relacionesRango[numeroRelacion]["fecha_fin"]}

}

export default ControlPresupuesto;